import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { COUNTRY_SELECTOR_POP_UP_CLASSES } from "./constants";

export const CountrySelectorPopupContainer = styled(Drawer)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.popup}`]: {
      padding: theme.spacing(7, 2, 0),
      [BREAKPOINT_TABLET]: {
        padding: theme.spacing(7, 4, 0),
      },
      [BREAKPOINT_DESKTOP]: {
        padding: theme.spacing(4, 6, 0),
      },
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.countryItemWrap}`]: {
      paddingLeft: theme.spacing(1),
      paddingTop: 0,
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.countryItem}`]: {
      display: "flex",
      padding: 0,
      ...theme.typography.body2,
      "&:focus-visible": {
        outline: "none",
      },
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.title}`]: {
      marginBottom: theme.spacing(2),
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.description}`]: {
      marginBottom: theme.spacing(2),
      maxWidth: "389px",
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.closeButton}`]: {
      position: "absolute",
      top: theme.spacing(1),
      left: theme.spacing(0.5),
      [BREAKPOINT_TABLET]: {
        left: theme.spacing(2.2),
      },
      [BREAKPOINT_DESKTOP]: {
        left: "auto",
        top: theme.spacing(1.5),
        right: theme.spacing(3.5),
      },
    },
    [`& .${COUNTRY_SELECTOR_POP_UP_CLASSES.icon}`]: {
      marginRight: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      "& img": {
        width: "22px",
        height: "16px",
      },
    },
  };
});
